import api from '../../utils/api';

const API_BASE_URL = "/admin/ADPModule"; // Adjust to match your backend API

const ADPModuleService = {
    async findAll(facilityCode: string): Promise<any> {
        const response = await api.get(`${API_BASE_URL}/find-all`, { params: { facilityCode } });
        return response.data;
    },

    async getItemById(moduleId: string): Promise<any> {
        const response = await api.get(`${API_BASE_URL}/find-one/${moduleId}`);
        return response.data;
    },

    async create(user: any): Promise<any> {
        const response = await api.post(`${API_BASE_URL}/create`, user);
        return response.data;
    },

    async update(moduleId: string, user: any): Promise<any> {
        const response = await api.put(`${API_BASE_URL}/update/${moduleId}`, user);
        return response.data;
    },

    async delete(moduleId: string): Promise<any> {
        const response = await api.delete(`${API_BASE_URL}/delete/${moduleId}`);
        return response.data;
    },

    async getDropdown(): Promise<any> {
        const response = await api.get(`${API_BASE_URL}/get-dropdown`);
        return response.data;
    }
};



export default ADPModuleService;